import { Link } from 'react-router';
import { useTitle } from '../lib/hooks.js';

const NotFound = () => {
  useTitle('Page not found');

  return (
    <div className="container section">
      <div className="empty-state">
        <h1>We cannot find that page</h1>
        <p>The link may be old, or the listing may have been taken down.</p>
        <div className="row-actions">
          <Link to="/" className="btn btn-outline">
            Go to the home page
          </Link>
          <Link to="/search" className="btn btn-primary">
            Browse listings
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
